/**
 * Shared navigation configuration for global navigation components.
 *
 * Fields:
 * - label: Text shown in navigation pills.
 * - href: Route passed to react-router for navigation.
 * - requiresAuth: Optional flag to hide links that require authentication
 *   when the current user is not logged in.
 */
export const HOME_ANCHOR_LINKS = [
  { label: 'Broadcast', href: '/', anchor: 'broadcast', requiresAuth: false, utmCampaign: 'listen_live' },
  { label: 'Colab Center', href: '/', anchor: 'colab-center', requiresAuth: false, utmCampaign: 'spark' },
  { label: 'Innovation Bots', href: '/', anchor: 'innovation-tools', requiresAuth: false, utmCampaign: 'toolkit' },
  { label: 'News Signal', href: '/', anchor: 'news', requiresAuth: false, utmCampaign: 'news_hub' },
  { label: 'Gig Passport', href: '/', anchor: 'gig-passport-section', requiresAuth: false, utmCampaign: 'gig_passport' },
];

export const NAVIGATION_LINKS = [
  { label: 'Home', href: '/', requiresAuth: true, utmCampaign: 'nav_home' },
  { label: 'Montreal Jazz', href: '/montreal-jazz', requiresAuth: false, utmCampaign: 'montreal_jazz' },
  { label: 'Journal', href: '/journal', requiresAuth: true, utmCampaign: 'nav_journal' },
  { label: 'News Hub', href: '/news', requiresAuth: false, utmCampaign: 'nav_news' },
  { label: 'Chronicle', href: '/radio', requiresAuth: false, utmCampaign: 'nav_radio' },
  { label: 'Insights', href: '/blog', requiresAuth: false, utmCampaign: 'nav_blog' },
  { label: 'Archives', href: '/chronicles', requiresAuth: true, utmCampaign: 'nav_archives' },
  { label: 'Gallery', href: '/portfolio', requiresAuth: true, utmCampaign: 'nav_gallery' },
  { label: 'Community Ledger', href: '/ledger', requiresAuth: false, utmCampaign: 'community_ledger' },
  { label: 'Radio Challenge', href: '/radio-challenge', requiresAuth: true, utmCampaign: 'radio_challenge' },
  { label: 'EduPlan', href: '/lesson-planner', requiresAuth: true, utmCampaign: 'lesson_planner' },
  { label: 'Gig Passport', href: '/passport', requiresAuth: false, utmCampaign: 'gig_passport' },
  { label: 'Creative Lab', href: '/creative-lab', requiresAuth: true, utmCampaign: 'collab_center' },
  { label: 'About', href: '/about', requiresAuth: false, utmCampaign: 'nav_about' },
  { label: 'Contact', href: '/contact', requiresAuth: true, utmCampaign: 'nav_contact' },
];

const cloneLink = (link) => ({ ...link });

export const getNavigationLinks = ({ includeHomeAnchors = false } = {}) => {
  const baseLinks = NAVIGATION_LINKS.map(cloneLink);
  if (!includeHomeAnchors) {
    return baseLinks;
  }
  return [...baseLinks, ...HOME_ANCHOR_LINKS.map(cloneLink)];
};

export default NAVIGATION_LINKS;
